// import './App.css';
import { useEffect, useState } from "react";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  TextField,
  Button,
} from "@material-ui/core";

import { getQuestionsByAssessmentSectionId } from "./../services/api";
import { FaEdit, FaRegTrashAlt } from "react-icons/fa";

function QuestionsTable({ questions, onElementSelected, onEdit, onDelete, selectedElementId }) {
  useEffect(() => {}, []);

  return (
    <div className="sectionsTable">
      <Button
        variant="contained"
        color="primary"
        className="btn-main-limber mb-15"
        onClick={() => {
          onEdit({});
        }}
      >
        Create Question
      </Button>
      <TableContainer
        component={Paper}
        style={{
          overflow: "auto",
          height: "95%",
        }}
      >
        <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Id</TableCell>
              <TableCell align="right">Name</TableCell>
              <TableCell align="right">Target</TableCell>
              <TableCell align="right">Edit</TableCell>
              <TableCell align="right">Delete</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {questions.map((question) => {
              let tr;
              if (question.questionTRs.length) {
                tr = question.questionTRs.find((x) => {
                  return x.language == "EN";
                });
                if (!tr) tr = question.questionTRs[0];
              }
              return (
                <TableRow
                  key={question.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  style={{
                    cursor: "pointer",
                    backgroundColor: selectedElementId === question.id ? "#c1cddd" : "transparent",
                  }}
                  onClick={(evt) => {
                    if (!evt.isDefaultPrevented()) {
                      onElementSelected(question);
                    }
                  }}
                >
                  <TableCell component="th" scope="row">
                    {question.id}
                  </TableCell>
                  <TableCell align="right">{tr ? tr.text : ""}</TableCell>
                  <TableCell align="right">{question.target}</TableCell>
                  <TableCell align="right">
                    <FaEdit
                      className="icon-limber"
                      size="1.5em"
                      onClick={(evt) => {
                        evt.preventDefault();
                        onEdit(question);
                      }}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <FaRegTrashAlt
                      className="icon-limber"
                      size="1.5em"
                      onClick={(evt) => {
                        evt.preventDefault();
                        onDelete(question);
                      }}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default QuestionsTable;
